import { Component, OnInit } from '@angular/core';
import { CssService } from '../../services/css.service';
import { Router } from '@angular/router';
import { TransitionCheckState } from '@angular/material/checkbox';

@Component({
  selector: 'app-css',
  templateUrl: './css.component.html',
  styleUrls: ['./css.component.css']
})
export class CssComponent implements OnInit {

  public css: string;
  public isLoading: boolean = false;

  constructor(
    private cssSvc: CssService,
    private router: Router
  ) { 

  }

  ngOnInit() {

    this.isLoading = true;
    this.cssSvc.getItem().then((s) => { 
      this.css = s.ReadingsCss;
      this.isLoading = false;
    });

  }

  public save() {
    this.cssSvc.save(this.css).then(
      () => {
        this.cancel();
      }
    ).catch((err)=> {
      alert("Could not save the style sheet");
      console.log(err);
    })
  
  }

  public cancel() { 
    this.router.navigate(['/admin']);
  }

}
